// extracted by mini-css-extract-plugin
module.exports = {"wrap":"mk-z","subtitle":"nk-z","contentWrap":"ok-z","imgWrap":"pk-z","heading":"qk-z","copy":"rk-z"};